import { Variable } from '@ff-scene-plugins/gift-shared/Variable';
import { SizeAttributeInput } from '@gift-variable-plugins/size-attribute-shared/SizeAttributeInput';
import { SizeAttributeOptions } from '@gift-variable-plugins/size-attribute-shared/SizeAttributeOptions';
import { SizeAttributeInputControl } from './SizeAttributeInputControl';

export const sizeAttributePdpPlugin: Variable.Plugin<SizeAttributeOptions, SizeAttributeInput> = {
    pluginId: 'size-attribute',
    InputControl: SizeAttributeInputControl,
    toFfCanvas: () => []
};